import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  key: 0,
  class: "step1-body"
};
var _hoisted_2 = {
  key: 1,
  class: "step2-body"
};
var _hoisted_3 = {
  key: 0
};
var _hoisted_4 = {
  class: "form-item"
};
var _hoisted_5 = {
  class: "form-item mt24"
};
var _hoisted_6 = {
  key: 1
};
var _hoisted_7 = {
  class: "form-item"
};
var _hoisted_8 = {
  class: "form-item mt24"
};
var _hoisted_9 = {
  key: 1,
  class: "count-down"
};
var _hoisted_10 = {
  key: 2
};
var _hoisted_11 = {
  class: "form-item"
};
var _hoisted_12 = {
  class: "form-item mt24"
};
var _hoisted_13 = {
  key: 1,
  class: "count-down"
};
import { ref, computed } from 'vue';
import { getStore, setStore, removeStore, clearStore } from '@/util/store';
import { getSendSmsCodes, getSendEmailCode, getUserCheckPwd, getVeriSmsCode, getVeriEmailCode, unbindMobile } from '@/api/user';
import { MessagePlugin } from 'tdesign-vue-next';
import { Encrypt } from '@/util/handelEncryptedData.js';

/* 变量 */

export default {
  __name: 'unbindPhoneDialog',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'reload'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    /* 工具 */

    var accessInfo = getStore({
      name: 'accessInfo'
    }); // 获取accessInfo
    var emit = __emit;
    var step = ref(1);
    var checkType = ref('');
    var account = ref('');
    var password = ref('');
    var phone = ref('');
    var phoneCode = ref('');
    var email = ref('');
    var emailCode = ref('');
    var countDown = ref(0);
    var timer = null;

    /* 计算属性 */
    var header = computed(function () {
      return step.value === 1 ? '1.解绑手机号-选择验证方式' : '2.解绑手机号-身份验证';
    });

    /* 事件 */
    var handleClose = function handleClose() {
      handleClear();
      emit('update:modelValue', false);
    };
    var handleClear = function handleClear() {
      step.value = 1;
      checkType.value = '';
      account.value = accessInfo.username;
      password.value = '';
      phone.value = accessInfo.phone;
      phoneCode.value = '';
      email.value = accessInfo.email;
      emailCode.value = '';
      countDown.value = 0;
      clearInterval(timer);
      timer = null;
    };
    var handleClick = function handleClick(type) {
      step.value = 2;
      checkType.value = type;
    };
    var setCountDown = function setCountDown() {
      countDown.value = 60;
      timer = setInterval(function () {
        countDown.value--;
        if (countDown.value === 0) clearInterval(timer);
      }, 1000);
    };
    var getPhoneCode = function getPhoneCode() {
      getSendSmsCodes(phone.value, 3).then(function (res) {
        if (res.data.code === 0) {
          setCountDown();
        }
      });
    };
    var getEmailCode = function getEmailCode() {
      getSendEmailCode(email.value, 4).then(function (res) {
        if (res.data.code === 0) {
          setCountDown();
        }
      });
    };
    var unbindPhone = function unbindPhone() {
      unbindMobile(accessInfo.user_id).then(function (res) {
        if (res.data.code === 0) {
          MessagePlugin.success('解绑成功！');
          setStore({
            name: 'accessInfo',
            content: _objectSpread(_objectSpread({}, accessInfo), {}, {
              phone: ''
            })
          });
          emit('reload');
          handleClose();
        }
      });
    };
    var checkAccount = function checkAccount() {
      var _password$value;
      if (((_password$value = password.value) === null || _password$value === void 0 ? void 0 : _password$value.length) === 0) {
        MessagePlugin.warning('请输入密码！');
      } else {
        var data = {
          userId: accessInfo.user_id,
          content: account.value,
          password: Encrypt(password.value)
        };
        getUserCheckPwd(data).then(function (res) {
          if (res.data.code === 0) {
            unbindPhone();
          }
        });
      }
    };
    var checkPhone = function checkPhone() {
      var _phoneCode$value;
      if (((_phoneCode$value = phoneCode.value) === null || _phoneCode$value === void 0 ? void 0 : _phoneCode$value.length) === 0) {
        MessagePlugin.warning('请输入验证码！');
      } else {
        getVeriSmsCode(phone.value, 3, phoneCode.value).then(function (res) {
          if (res.data.code === 0) {
            unbindPhone();
          }
        });
      }
    };
    var checkEmail = function checkEmail() {
      var _emailCode$value;
      if (((_emailCode$value = emailCode.value) === null || _emailCode$value === void 0 ? void 0 : _emailCode$value.length) === 0) {
        MessagePlugin.warning('请输入验证码！');
      } else {
        getVeriEmailCode(email.value, 4, emailCode.value).then(function (res) {
          if (res.data.code === 0) {
            unbindPhone();
          }
        });
      }
    };
    var handleSure = function handleSure() {
      if (checkType.value === 'account') {
        checkAccount();
      } else if (checkType.value === 'phone') {
        checkPhone();
      } else if (checkType.value === 'email') {
        checkEmail();
      }
    };
    return function (_ctx, _cache) {
      var _component_t_input = _resolveComponent("t-input");
      var _component_t_button = _resolveComponent("t-button");
      var _component_t_dialog = _resolveComponent("t-dialog");
      return _openBlock(), _createBlock(_component_t_dialog, {
        class: "unbind-phone-dialog",
        width: "480px",
        visible: __props.modelValue,
        header: header.value,
        footer: step.value === 2,
        onClose: handleClose,
        onOpened: handleClear
      }, {
        footer: _withCtx(function () {
          return [_createVNode(_component_t_button, {
            theme: "default",
            onClick: handleClear
          }, {
            default: _withCtx(function () {
              return _toConsumableArray(_cache[17] || (_cache[17] = [_createTextVNode("上一步", -1)]));
            }),
            _: 1
          }), _createVNode(_component_t_button, {
            onClick: handleSure
          }, {
            default: _withCtx(function () {
              return _toConsumableArray(_cache[18] || (_cache[18] = [_createTextVNode("确定", -1)]));
            }),
            _: 1
          })];
        }),
        default: _withCtx(function () {
          return [step.value === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_cache[9] || (_cache[9] = _createElementVNode("span", {
            class: "wfull"
          }, "请在下方选择一项进行身份验证！", -1)), _unref(accessInfo).username ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "btn wfull mt24",
            onClick: _cache[0] || (_cache[0] = function ($event) {
              return handleClick('account');
            })
          }, "账号+密码")) : _createCommentVNode("", true), _unref(accessInfo).phone ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: "btn wfull mt24",
            onClick: _cache[1] || (_cache[1] = function ($event) {
              return handleClick('phone');
            })
          }, "手机+验证码")) : _createCommentVNode("", true), _unref(accessInfo).email ? (_openBlock(), _createElementBlock("span", {
            key: 2,
            class: "btn wfull mt24",
            onClick: _cache[2] || (_cache[2] = function ($event) {
              return handleClick('email');
            })
          }, "邮箱+验证码")) : _createCommentVNode("", true), _cache[10] || (_cache[10] = _createElementVNode("span", {
            class: "tip mt24"
          }, "若无法验证，请联系系统超级管理员进行修改", -1))])) : _createCommentVNode("", true), step.value === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [checkType.value === 'account' ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_cache[11] || (_cache[11] = _createElementVNode("span", {
            class: "label must"
          }, "账号", -1)), _createVNode(_component_t_input, {
            class: "mt8",
            modelValue: account.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
              return account.value = $event;
            }),
            disabled: ""
          }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_5, [_cache[12] || (_cache[12] = _createElementVNode("span", {
            class: "label must"
          }, "密码", -1)), _createVNode(_component_t_input, {
            class: "mt8",
            modelValue: password.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
              return password.value = $event;
            }),
            type: "password",
            placeholder: "请输入密码"
          }, null, 8, ["modelValue"])])])) : _createCommentVNode("", true), checkType.value === 'phone' ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_cache[13] || (_cache[13] = _createElementVNode("span", {
            class: "label must"
          }, "手机号", -1)), _createVNode(_component_t_input, {
            class: "mt8",
            modelValue: phone.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
              return phone.value = $event;
            }),
            disabled: ""
          }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_8, [_cache[14] || (_cache[14] = _createElementVNode("span", {
            class: "label must"
          }, "验证码", -1)), _createVNode(_component_t_input, {
            class: "mt8",
            modelValue: phoneCode.value,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
              return phoneCode.value = $event;
            }),
            placeholder: "请输入验证码"
          }, {
            suffix: _withCtx(function () {
              return [countDown.value === 0 ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "txt-btn",
                onClick: getPhoneCode
              }, "发送验证码")) : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(countDown.value) + " s", 1))];
            }),
            _: 1
          }, 8, ["modelValue"])])])) : _createCommentVNode("", true), checkType.value === 'email' ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_cache[15] || (_cache[15] = _createElementVNode("span", {
            class: "label must"
          }, "邮箱", -1)), _createVNode(_component_t_input, {
            class: "mt8",
            modelValue: email.value,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) {
              return email.value = $event;
            }),
            disabled: ""
          }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_12, [_cache[16] || (_cache[16] = _createElementVNode("span", {
            class: "label must"
          }, "验证码", -1)), _createVNode(_component_t_input, {
            class: "mt8",
            modelValue: emailCode.value,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = function ($event) {
              return emailCode.value = $event;
            }),
            placeholder: "请输入验证码"
          }, {
            suffix: _withCtx(function () {
              return [countDown.value === 0 ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "txt-btn",
                onClick: getEmailCode
              }, "发送验证码")) : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(countDown.value) + " s", 1))];
            }),
            _: 1
          }, 8, ["modelValue"])])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["visible", "header", "footer"]);
    };
  }
};